import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FDF8F6] font-sans text-gray-900">
      {/* Navigation */}
      <nav className="p-6 flex justify-between items-center max-w-7xl mx-auto">
        <div
          onClick={() => navigate('/')}
          className="flex items-center gap-2 cursor-pointer"
        >
          <img src="/favicon.png" alt="TableAR Logo" className="w-8 h-8 object-contain" />
          <span className="font-bold text-xl">TableAR</span>
        </div>
        <button onClick={() => navigate('/')} className="text-gray-500 hover:text-[#ee5b2b] font-medium">
          ← Back to Home
        </button>
      </nav>

      {/* Hero */}
      <div className="max-w-4xl mx-auto px-6 py-16 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">Revolutionizing the Dining Experience</h1>
        <p className="text-xl text-gray-600 leading-relaxed">
          We believe food should be experienced before it's ordered. TableAR bridges the gap between imagination and reality using augmented reality.
        </p>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-6 pb-20 grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <h2 className="text-3xl font-bold">Our Story</h2>
          <p className="text-gray-600">
            TableAR started with a simple frustration: "Why does the food never look like the picture?"
            We realized that static images on a printed menu or a basic website weren't enough to capture the artistry of a chef's creation. People eat with their eyes first, and uncertainty about portion size or ingredients can often lead to "order envy."
          </p>
          <p className="text-gray-600">
            We set out to bridge the gap between imagination and reality. By leveraging cutting-edge WebXR technology, we allow restaurants to create high-fidelity digital twins of their dishes. This isn't just about showing a picture; it's about bringing the menu to life right on your table, in true-to-life scale and detail.
          </p>
          <p className="text-gray-600">
            Our platform requires no apps to download—just a simple QR code scan. We are democratizing Augmented Reality for the dining industry, making it accessible, seamless, and magical. We believe that the future of dining is interactive, transparent, and beautiful.
          </p>
        </div>
        <div>
          <img
            src="https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=800&q=80"
            alt="Team meeting"
            className="rounded-2xl shadow-xl"
          />
        </div>
      </div>
    </div >
  );
};

export default AboutUs;